<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/sjwh">盛京文化</router-link> >
      <router-link to="/sjwh/zhoukan">盛京医讯</router-link>
    </div>

    <div class="container-width yixun">
      <div class="l-img">
        <div class="block z-fm">
          <img :src="current.img" />
        </div>
        <p>{{ current.title }}</p>
      </div>
      <div class="r-list">
        <ul>
          <li
            @click="goList(item)"
            v-for="(item, index) in list"
            :key="index"
            class="li-item"
          >
            <span class="title">{{ item.title }}</span
            ><span class="date">【{{ item.releaseDate }}】</span>
          </li>
          <!-- <li class="li-item">
            <a @click="handleBeforeLLink"
              ><span>{{ currentYear }}年以前内容请点击这里进行查看</span></a
            >
          </li> -->
          <nav>
            <Pagination
              :pageCount="totalPages"
              :total="total"
              @togglePage="togglePage($event)"
            ></Pagination>
          </nav>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import service from "../../service/sjwh";
import config from "../../config/dev";
import BANNER from "../../components/banner/sjwh";
export default {
  name: "ZHOUKAN",
  data() {
    return {
      navigationData: [
      {
          name: "百年历史",
          path: "/sjwh",
          width: "50%",
        },
        {
          name: "院标/办院理念/院训/院歌",
          path: "/sjwh/yuange",
          width: "50%",
        },
        {
          name: "盛京医讯",
          path: "/sjwh/zhoukan",
          width: "33%",
        },
        {
          name: "盛京TV",
          path: "/sjwh/tv",
        },
        {
          name: "盛京映像",
          path: "/sjwh/yingxiang",
        },
        // {
        //   name: "盛京医院的故事",
        //   path: "/sjwh/gushi",
        // },
      ],
      currentPath: "/sjwh/zhoukan",
      list: [],
      current: {},
      pageIndex: 1,
      pageSize: window.screen.width < 720 ? 6 : 10,
      totalPages: 1,
      total: 0,
      currentYear: "",
      beforeListContent: "",
    };
  },
  components: { BANNER },
  computed: {},
  created() {
    this.init();
    this.getBeforeList();
  },
  beforeMount() {},
  methods: {
    // 当年周刊列表
    init() {
      let d = new Date();
      let parmes = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        currentYear: d.getFullYear(),
        isshow: 1,
      };
      service.getwzSjMedicalInformationList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.releaseDate = item.releaseDate
              ? item.releaseDate.substr(0, 10)
              : "";
            item.img =
              config.url +
              "/file/downloadFile/" +
              item.img +
              "?isDownload=true";
          });
        }
        this.list = res.content || [];
        this.current = { ...res.content[0] };
        this.total = res.totalElements;
        this.totalPages = parseInt(res.totalPages) || 0;
      });
    },
    // 获取当年以前周刊列表
    getBeforeList() {
      let d = new Date();
      let parmes = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        before: d.getFullYear(),
      };
      service.getwzSjMedicalInformationList(parmes, (res) => {
        this.beforeListContent = res.content[0] || {};
      });
    },
    // 当前以前的数据链接地址
    handleBeforeLLink() {
      if (this.beforeListContent.url) {
        window.open(this.beforeListContent.url, "_blank");
      } else {
        const { href } = this.$router.resolve({
          path: `/sjwh/zhoukan/list`,
          query: {
            id: this.beforeListContent.id,
          },
        });
        window.open(href, "_blank");
      }
    },
    goList(e) {
      if (e.url) {
        window.open(e.url, "_blank");
      } else {
        const { href } = this.$router.resolve({
          path: `/sjwh/zhoukan/list`,
          query: {
            id: e.id,
          },
        });
        window.open(href, "_blank");
      }
    },
    togglePage(indexPage) {
      this.pageIndex = indexPage;
      this.init();
    },
  },
  mounted() {
    let d = new Date();
    this.currentYear = d.getFullYear();
  },
  watch: {},
};
</script>


<style scoped lang="scss">
.yixun {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-top: 50px;
  .l-img {
    width: 280px;
    p {
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 1.2rem;
    }
  }
  .r-list {
    width: calc(100% - 310px);
    ul {
      border: 1px solid #ebebeb;
      margin-bottom: 50px;
      .li-item {
        cursor: pointer;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #ebebeb;
        padding: 0 30px;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        -ms-flex-pack: justify;
        justify-content: space-between;
      }
      li-item:last-child {
        border-bottom: none;
      }
    }
  }
  .block {
    box-shadow: 0px 0px 59px 0px rgba(19, 40, 83, 0.1);
  }
  .z-fm {
    box-shadow: 0px 0px 59px 0px rgba(19, 40, 83, 0.3);
    img {
      width: 280px;
      height: 396.8px;
    }
  }

  .pagination {
    margin-top: 30px;
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 728px) {
  .yixun {
    flex-direction: column;
    justify-content: center;
    align-items: center;
   
    .r-list {
      width: 100%;
    }
  }
}
</style>